"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outbox = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const outbox = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'outbox-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3 11.25C3.41421 11.25 3.75 11.5858 3.75 12L3.75 16.25H16.25V12C16.25 11.5858 16.5858 11.25 17 11.25C17.4142 11.25 17.75 11.5858 17.75 12V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17L2.25 12C2.25 11.5858 2.58579 11.25 3 11.25Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10 1.93929L13.5303 5.46962C13.8232 5.76251 13.8232 6.23738 13.5303 6.53028C13.2374 6.82317 12.7626 6.82317 12.4697 6.53028L10.75 4.81061V13.4499C10.75 13.8642 10.4142 14.1999 10 14.1999C9.58579 14.1999 9.25 13.8642 9.25 13.4499V4.81061L7.53033 6.53028C7.23744 6.82317 6.76256 6.82317 6.46967 6.53028C6.17678 6.23738 6.17678 5.76251 6.46967 5.46962L10 1.93929Z', fill: '#4B5563' })));
};
exports.outbox = outbox;
